const terminal49tracking = {
  Authorization: "Token WJ8mwNFGkvovorqCqxabeBCK",
};

export default terminal49tracking;
